// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__GrUtG","cross":"Loader_cross__KOqCs","dark":"Loader_dark__gHK0g"};